import { LayoutActionType } from './constant';

/**
 @typedef {import("./constant").LayoutState} LayoutState
 *
 */

/**
 * Layout reducer
 * @param   {LayoutState}   state   state before
 * @param   {object}        action  state before
 *
 * @returns {LayoutState}   Layout state
 */
export function layoutReducer(state, action) {
  switch (action.type) {
    case LayoutActionType.LOAD:
      return { ...(action.data || {}) };

    case LayoutActionType.RIGHT_PANEL_SHOW:
      return { ...state, rightPanelItemKey: action.item };

    case LayoutActionType.RIGHT_PANEL_HIDE:
      return { ...state, rightPanelItemKey: null };

    case LayoutActionType.BOTTOM_PANEL_SHOW:
      return { ...state, bottomPanelState: 'normal' };

    case LayoutActionType.BOTTOM_PANEL_COLLAPSE:
      return { ...state, bottomPanelState: 'collapsed' };

    case LayoutActionType.BOTTOM_PANEL_EXPAND:
      return { ...state, bottomPanelState: 'expand' };

    case LayoutActionType.TRADE_PANEL_SHOW:
      return { ...state, tradePanelShow: true };

    case LayoutActionType.TRADE_PANEL_HIDE:
      return { ...state, tradePanelShow: false };

    default:
      return { ...state };
  }
}
